export default __webpack_public_path__ + "static/media/Footer.37460184.svg";